<template>
  <v-container class="card-container">
    <v-row class="row__ pa-0 pb-1 white">
      <v-tabs
        v-model="tab"
        background-color="white"
        color="primary"
        style="height: 42px"
        class="ma-0 d-flex justify-center"
      >
        <v-tab class="custom-tab">
          {{ $tc("nav.gestionTiempos") }}
        </v-tab>
        <v-tab
          class="custom-tab"
          v-show="verifyExistingAction('tab:editarregistraciones')"
        >
          {{ $tc("gestionTiempos.registrations") }}
        </v-tab>
      </v-tabs>
    </v-row>

    <v-container class="ma-0 pa-0 pt-3">
      <div style="display: flex; flex-direction: row">
        <v-row class="row-container pa-0 ma-0 my-3">
          <filters
            :dispatch="dispatch"
            @onRefresh="refresh"
            class="mr-3"
            @flagApply="flag"
            :viewRegis="tab === 0 ? true : false"
          />
          <div style="display: flex; align-items: center">
            <Date :dispatch="dispatch" />
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="btn-refresh ml-4"
                  v-bind="attrs"
                  @click="onRefreshItem"
                  v-on="on"
                  :disabled="deleteDisabled"
                  id="btn-disabled"
                >
                  <v-img
                    src="../../assets/icons/actualizar-osc.png"
                    alt="actualizar"
                    max-width="25"
                  />
                </v-btn>
              </template>
              <span>{{ $tc("gestionTiempos.refresh") }}</span>
            </v-tooltip>
          </div>

          <div class="firms">
            <div v-for="item in buttonsActions" :key="item.name">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-2"
                    id="btn-actions"
                    v-bind="attrs"
                    @click="item.function"
                    v-on="on"
                    :disabled="!item.disabled"
                    v-show="item.name === 'Agregar registración' || tab === 0"
                  >
                    <v-icon class="icon-btn-actions">{{ item.icon }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.name }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-row>
      </div>

      <new-controller @listchange="itemsSelections" v-if="tab === 0" />
      <TableWithSearch
        v-else
        :items="regis"
        :headers="headersRegis"
        :openDialog="openDialog"
        :showAdd="false"
        :heightTable="'71.5vh'"
        :isRegistrations="true"
      />

      <!-------------------------------------------------------------------------->
      <!---------------------------Eliminar---------------------------------------->
      <v-dialog
        v-model="showDelete"
        max-width="350px"
        @keydown.esc="showDelete = false"
        @keydown.enter="deleteItem"
        persistent
      >
        <CardDialog style="max-width: 350px; overflow: hidden">
          <template slot="title">
            {{ $tc("editRegistrations.deleteItem") }}
          </template>
          <template slot="body">
            <v-alert
              dense
              v-if="error"
              color="red"
              elevation="5"
              outlined
              text
              type="error"
              align="center"
              class="mr-1 ml-1"
            >
              {{ alertValidate }}</v-alert
            >
            <v-autocomplete
              dense
              :label="$tc('editRegistrations.audit')"
              class="mt-4"
              outlined
              :items="getAudit"
              item-text="comment"
              item-value="id"
              v-model="itemsToDelete.audit"
              v-show="!showAudit"
            />
            <v-card-actions class="justify-space-between pa-0 pt-2 mb-n3">
              <v-btn
                class="bt-exit"
                large
                height="36"
                min-width="100"
                @click="showDelete = false"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn
                class="bt-acept"
                large
                height="36"
                min-width="100"
                @click.prevent="deleteItem"
              >
                {{ $tc("editRegistrations.delete") }}</v-btn
              >
            </v-card-actions>
          </template>
        </CardDialog>
      </v-dialog>

      <!------------------------------------------------------------------------->
      <!---------------------------Editar---------------------------------------->
      <v-dialog
        v-model="showEdit"
        max-width="530px"
        @keydown.esc="cancel"
        @keydown.enter="auditEdit"
        persistent
      >
        <CardDialog max-width="530px">
          <template slot="title"
            >{{ $tc("editRegistrations.editRegis") }}
          </template>
          <template slot="body">
            <v-alert
              dense
              v-if="error"
              color="red"
              elevation="5"
              outlined
              text
              type="error"
              align="center"
              class="mx-2"
            >
              {{ alertValidate }}</v-alert
            >
            <v-form
              ref="formEdit"
              v-model="validEdit"
              lazy-validation
              class="mx-2"
            >
              <v-autocomplete
                dense
                :label="$tc('editRegistrations.concept')"
                :items="getConceptsEditDay"
                :item-text="formatConcept"
                item-value="conceptId"
                outlined
                style="height: 70px"
                v-model="editItems.conceptoId"
                @change="conceptsHours()"
                v-if="showEditDay"
              />
              <v-autocomplete
                dense
                :label="$tc('editRegistrations.concept')"
                :items="getConceptsEditHours"
                :item-text="formatConcept"
                item-value="conceptId"
                outlined
                style="height: 70px"
                v-model="editItems.conceptoId"
                @change="conceptsHours()"
                v-else
              />

              <div class="mx-3 mb-3">
                <DateRegis :showCheck="showCheck" />
              </div>

              <div class="pt-4">
                <Time v-if="showHours" />
              </div>

              <v-autocomplete
                denseclass="mt-2"
                :label="$tc('editRegistrations.csCosts')"
                :items="getCosts"
                item-text="name"
                item-value="id"
                outlined
                v-model="editItems.csCostoId"
                required
                :rules="rules"
              />
              <v-autocomplete
                dense
                :label="$tc('editRegistrations.audit')"
                outlined
                :items="getAudit"
                item-text="comment"
                item-value="id"
                v-model="editItems.comentId"
                v-show="showAudit"
              />
              <v-textarea
                :label="$tc('editRegistrations.observations')"
                color="primary"
                rows="1"
                outlined
                v-model="editItems.observaciones"
              />
            </v-form>
            <v-card-actions class="justify-space-between px-2 pa-0 pt-2 mb-n3">
              <v-btn
                class="bt-exit"
                @click="cancel"
                large
                height="36"
                min-width="100"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn
                class="bt-acept"
                @click.prevent="auditEdit"
                large
                height="36"
                min-width="100"
              >
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </v-card-actions>
          </template>
          <template slot="actions"> </template>
        </CardDialog>
      </v-dialog>
      <!------------------------------------------------------------------------->
    </v-container>

    <snackbar :alert="alert" :color="color" :textAlert="textAlert" />

    <v-dialog
      v-model="addRegistration"
      max-width="530px"
      persistent
      @keydown.esc="reset"
    >
      <FormAddRegistration @save="validateAndSubmit" @cancel="reset" />
    </v-dialog>
    <v-dialog v-model="showDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="pa-4">
          <v-alert
            dense
            outlined
            type="error"
            class="text-center"
            v-html="dialogMessage"
          >
          </v-alert>
        </v-card-title>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn
            class="bt-exit"
            large
            height="36"
            @click="confirmDialog(false)"
            >{{ $tc("commons.cancel") }}</v-btn
          >
          <v-btn
            class="bt-acept"
            large
            height="36"
            @click="confirmDialog(true)"
            >{{ $tc("commons.accept") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showMessage" max-width="500" persistent>
      <v-card>
        <v-card-title class="px-2 py-2">
          <v-alert dense outlined type="error" class="text-center mx-auto">
            {{ message }}
          </v-alert>
        </v-card-title>
        <v-card-actions class="d-flex justify-center mt-n5">
          <v-btn
            class="bt-acept"
            large
            height="36"
            @click="showMessage = false"
          >
            {{ $tc("commons.accept") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alertCheckDeadlines" max-width="400" persistent>
      <v-card>
        <v-card-title class="px-2 py-2">
          <v-alert dense outlined type="error" class="text-center mx-auto">
            {{ $tc("gestionTiempos.alertCheckDeadlines") }}
          </v-alert>
        </v-card-title>
        <v-card-actions class="justify-space-between">
          <v-btn
            class="bt-exit"
            large
            height="36"
            min-width="100"
            @click="alertCheckDeadlines = false"
          >
            {{ $tc("commons.cancel") }}
          </v-btn>
          <v-btn
            class="bt-acept"
            large
            height="36"
            min-width="100"
            @click="confirmCheckDeadlines"
            >{{ $tc("commons.accept") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import ToolbarTitles from "../Complement/ToolbarTitles.vue";
import Filters from "./Filters.vue";
import Date from "./Date.vue";
import NewController from "./NewController.vue";
import signNovelty from "../../store/gestionTiempos/signNovelty";
import Alerts from "../GestionEmpleados/commons/Alerts.vue";
import permissions from "../mixins/permissions";
import FormAddRegistration from "./FormAddRegistration.vue";
import date from "../../store/common/date";
import registrations from "../../store/gestionTiempos/registrations";
import snackbar from "../Complement/Snackbar.vue";
import relations from "@/store/autorizaciones/relations";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import Time from "./Actions/DetalleDelDia/Time.vue";
import DataTable from "./Actions/common/DataTable.vue";
import CardDialog from "./Actions/common/CardDialog.vue";
import DateRegis from "./Actions/common/DateRegis.vue";

export default {
  mixins: [permissions],
  components: {
    ToolbarTitles,
    Filters,
    Date,
    NewController,
    Alerts,
    FormAddRegistration,
    snackbar,
    TableWithSearch,
    DateRegis,
    DataTable,
    CardDialog,
    Time,
  },
  data() {
    return {
      textAlert: "",
      alert: false,
      color: "",
      loading: true,
      dialog: false,
      refreshItem: [],
      flagApply: null,
      deselectItems: null,
      idRol: null,
      showMessage: false,
      message: "",
      tab: 0,
      headersRegis: [
        {
          text: "Empleado",
          value: "nameEmp",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Legajo",
          value: "legajo",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Entrada",
          value: "entryTable",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Salida",
          value: "exit",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Concepto",
          value: "nameConcept",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Centro de Costo",
          value: "nameCc",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Observaciones",
          value: "obs",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      showEdit: false,
      typeForm: "",
      alertValidate: "",
      itemsToDelete: {
        audit: null,
      },
      isDay: false,
      originEnd: null,
      originStart: null,
      dialogGreater: false,
      showHours: null,
      showEditDay: false,
      endMenuTime: false,
      endMenuCalendar: false,
      startTimeMenu: false,
      startCalendarMenu: false,
      error: false,
      valid: true,
      validEdit: true,
      showCheck: true,
      rules: [
        (v) => (v !== null && v !== undefined && v !== "") || "Requerido",
      ],
      showAdd: false,
      date: null,
      close: false,
      editItems: {
        comentId: null,
        observaciones: "",
      },
      originalEditItems: {}, // Almacena los valores originales para comparar cambios
      errorValidate: false,
      alertMessageValidate: "",
      showDialog: false,
      dialogMessage: "",
      payloadToSave: null,
      showAudit: false,
      showDelete: false,
      alertCheckDeadlines: false,
      alertCheckDeadlinesAction: "",
      data: {
        concept: null,
        startDay: this.$store.state.gestionTiempos.dateFromComponents,
        endDay: this.$store.state.gestionTiempos.dateToComponents,
        timeStartDay: "00:00",
        timeEndDay: "00:00",
        cost: null,
        audit: null,
        observations: "",
      },
    };
  },

  async mounted() {
    this.idRol = parseInt(localStorage.getItem("rolId"), 10);
    await relations.commit("setEdit", { id: this.idRol });
    await relations.dispatch("getRolCostCenters");
    await relations.dispatch("getRolComents");
    await relations.dispatch("getRolConcepts");

    this.$store.dispatch("gestionTiempos/getFilters").then(() => {
      this.loading = false;
    });
    this.checkArrays();
  },
  computed: {
    regis() {
      return this.$store.state.gestionTiempos.regis;
    },
    concepts() {
      return relations.state.concepts;
    },
    coments() {
      return relations.state.coments;
    },
    costCenters() {
      return relations.state.costCenters;
    },
    getConcepts() {
      return registrations.state.concepts;
    },
    getConceptsEditHours() {
      let conceptsHours = registrations.state.concepts.filter((element) => {
        return element.licTot === "N";
      });

      return conceptsHours;
    },
    getConceptsEditDay() {
      let conceptsDay = registrations.state.concepts.filter((element) => {
        return element.licTot !== "N";
      });

      return conceptsDay;
    },
    getCosts() {
      return registrations.state.csCosts;
    },
    getAudit() {
      return registrations.state.audit;
    },
    deleteDisabled: {
      get() {
        return this.$store.state.gestionTiempos.deleteDisabled;
      },
      set(newValue) {
        return newValue;
      },
    },
    addRegistration: {
      get() {
        return this.$store.state.gestionTiempos.addRegistration;
      },
      set(newValue) {
        return newValue;
      },
    },
    buttonsActions() {
      return [
        {
          name: this.$tc("gestionTiempos.addRegistration"),
          icon: "mdi-file-plus",
          function: this.openAddRegistration,
          disabled: this.can("accion:agregarregistracion"),
        },
        {
          name: this.$tc("gestionTiempos.firm"),
          icon: "mdi-file-sign",
          function: this.firnNovelty,
          disabled: this.can("accion:firmarretirar"),
        },
        {
          name: this.$tc("gestionTiempos.removeFirm"),
          icon: "mdi-file-remove-outline",
          function: this.notFirmNovelty,
          disabled: this.can("accion:firmarretirar"),
        },
      ];
    },
  },

  methods: {
    formatConcept(item) {
      if (!item || !item.name) return "";
      const tipo =
        item.licTot === "S" ? " (Días)" : item.licTot === "N" ? " (Horas)" : "";
      return `${item.name}${tipo}`;
    },
    formatDateEdit(item, date) {
      let part = item.split(" ");
      if (date == "date") {
        return moment(part[0], "DD-MM-YYYY").format("YYYY-MM-DD");
      } else {
        return part[1];
      }
    },
    verifyExistingAction(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },
    async openDialog(type, item) {
      this.typeForm = type;
      let audit;
      await registrations.dispatch("getAudit").then(() => {
        audit = registrations.state.audit;
      });

      switch (this.typeForm) {
        case "edit":
          this.alertCheckDeadlinesAction = "edit";
          this.auditTrue();
          await registrations.dispatch("getConcepts").then(() => {});
          await registrations.dispatch("getCsCostGuidelines").then(() => {
            this.showEdit = true;
          });

          let conceptId = registrations.state.concepts.find((option) => {
            return option.conceptId == item.conceptId;
          });
          if (conceptId.licTot == "S") {
            this.showHours = false;
            this.showEditDay = true;
            this.isDay = true;
          } else {
            this.showHours = true;
            this.showEditDay = false;
            this.isDay = false;
          }
          this.$forceUpdate();
          let csCostId = registrations.state.csCosts.filter((option) => {
            return option.id == item.ccId;
          });
          let entrada = this.formatDateEdit(item.entry, "date");
          let hoursEntry = this.formatDateEdit(item.entry, "time");
          let salida = this.formatDateEdit(item.exit, "date");
          let hoursExit = this.formatDateEdit(item.exit, "time");
          this.$store.commit("gestionTiempos/setTimeTo", hoursExit);

          if (item.licTot === "N") {
            if (entrada === salida && hoursEntry === hoursExit) {
              this.$store.commit("gestionTiempos/setTimeFrom", null);
              this.$store.commit("gestionTiempos/setDateFromComponents", null);
            } else {
              this.$store.commit("gestionTiempos/setTimeFrom", hoursEntry);
              this.$store.commit(
                "gestionTiempos/setDateFromComponents",
                entrada
              );
            }
          } else {
            this.$store.commit("gestionTiempos/setTimeFrom", hoursEntry);
            this.$store.commit("gestionTiempos/setDateFromComponents", entrada);
          }
          this.$store.commit("gestionTiempos/setDateToComponents", salida);

          const entradaDate = moment(item.entry, "DD-MM-YYYY HH:mm");
          const salidaDate = moment(item.exit, "DD-MM-YYYY HH:mm");

          if (conceptId.licTot === "S") {
            // Diferencia en días
            this.saldoEdit = Math.abs(salidaDate.diff(entradaDate, "days")) + 1;
          } else {
            // Diferencia en horas
            this.saldoEdit = Math.abs(entradaDate.diff(salidaDate, "hours"));
          }
          this.saldoEdit = this.saldoEdit === NaN ? 0 : this.saldoEdit;
          this.editItems = {
            conceptoId: item.conceptId,
            fecha: moment.utc().format("YYYY-MM-DD"),
            fechaEntrada: entrada === salida ? null : entrada,
            horaEntrada: hoursEntry,
            fechaSalida: salida,
            horaSalida: hoursExit,
            csCostoId: csCostId[0].id,
            observaciones: item.obs === null ? "" : item.obs,
            empId: item.empId,
            comentId: audit[0].id,
            licTot: item.licTot,
            entryOrigin: item.entryOrigin,
          };
          // Guardar los valores originales para comparación
          this.originalEditItems = { ...this.editItems };
          break;
        case "delete":
          this.showDelete = true;

          this.itemsToDelete = {
            empId: item.empId,
            entrada: item.entry,
            fecha: moment(item.entry, "YYYY-MM-DD").format("YYYY-MM-DD"),
            audit: audit[0].id,
          };
          this.auditTrue();
          break;
        default:
          break;
      }
    },

    cancel() {
      this.showEdit = false;
      this.error = false;
      this.data = {
        concept: null,
        startDay: this.$store.state.gestionTiempos.dateFromComponents,
        endDay: this.$store.state.gestionTiempos.dateToComponents,
        timeStartDay: this.$store.state.gestionTiempos.timeFrom,
        timeEndDay: this.$store.state.gestionTiempos.timeTo,
        cost: null,
        audit: null,
        observations: "",
      };
    },

    auditEdit() {
      if (this.showAudit == true) {
        if (this.editItems.comentId == undefined) {
          this.error = true;
          this.alertValidate = this.$tc("editRegistrations.required");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.validateEdit();
        }
      } else {
        this.validateEdit();
      }
    },
    validateEdit() {
      if (
        !this.$store.state.gestionTiempos.dateFromComponents ||
        this.$store.state.gestionTiempos.dateFromComponents === "Invalid date"
      ) {
        this.error = true;
        this.alertValidate = this.$tc("alert.errorDateFrom");
        setTimeout(() => {
          this.error = false;
        }, 3500);
        return;
      }
      if (
        !this.$store.state.gestionTiempos.dateToComponents ||
        this.$store.state.gestionTiempos.dateToComponents === "Invalid date"
      ) {
        this.error = true;
        this.alertValidate = this.$tc("alert.errorDateTo");
        setTimeout(() => {
          this.error = false;
        }, 3500);
        return;
      }

      if (
        moment(this.$store.state.gestionTiempos.dateFromComponents).isAfter(
          this.$store.state.gestionTiempos.dateToComponents
        )
      ) {
        this.error = true;
        this.alertValidate = this.$tc("alert.errorDates");
        setTimeout(() => {
          this.error = false;
        }, 3500);
        return;
      }

      const valid = this.$refs.formEdit.validate();
      if (!valid) {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
        return;
      }
      this.dateEditStartIso = `${
        this.$store.state.gestionTiempos.dateFromComponents
      }T${this.$store.state.gestionTiempos.timeFrom || "00:00"}:00.000Z`;
      this.dateEditEndIso = `${
        this.$store.state.gestionTiempos.dateToComponents ||
        moment().format("YYYY-MM-DD")
      }T${this.$store.state.gestionTiempos.timeTo || "00:00"}:00.000Z`;
      if (this.isDay) {
        if (moment(this.dateEditStartIso).isAfter(this.dateEditEndIso)) {
          this.error = true;
          this.alertValidate = this.$tc("editRegistrations.less");
          setTimeout(() => {
            this.error = false;
          }, 2500);
          return;
        }
        this.editItems.fechaEntrada = moment(
          this.$store.state.gestionTiempos.dateFromComponents
        ).format("YYYY-MM-DD");
        this.editItems.fechaSalida = moment(
          this.$store.state.gestionTiempos.dateToComponents
        )
          .add(1, "days")
          .format("YYYY-MM-DD");
      } else {
        this.editItems.fechaEntrada = moment
          .utc(this.dateEditStartIso)
          .format("YYYY-MM-DD HH:mm:ss");
        this.editItems.fechaSalida = moment
          .utc(this.dateEditEndIso)
          .format("YYYY-MM-DD HH:mm:ss");
      }
      this.editRegis();
    },

    async editRegis() {
      let payload = {
        empId: this.editItems.empId,
        entradaOriginal: this.editItems.entryOrigin,
        fecha: this.editItems.fecha,
      };

      // Comparar los valores actuales con los originales y agregar solo los que cambiaron
      Object.keys(this.editItems).forEach((key) => {
        if (
          this.editItems[key] !== this.originalEditItems[key] &&
          key !== "empId" &&
          key !== "entryOrigin" &&
          key !== "fecha"
        ) {
          payload[key] = this.editItems[key];
        }
      });

      let conceptId = registrations.state.concepts.find((option) => {
        return option.conceptId == this.editItems.conceptoId;
      });
      let csCostId = registrations.state.csCosts.find((option) => {
        return option.id == this.editItems.csCostoId;
      });

      if (payload.conceptoId) {
        payload.nombreConcepto = conceptId.name.trim();
      }
      if (payload.csCostoId) {
        payload.nombreCsCosto = csCostId.name.trim();
      }

      if (this.editItems.observaciones !== "") {
        payload.observaciones = this.editItems.observaciones;
      }

      const isValid = await this.validarSaldos(
        payload,
        conceptId.licTot,
        this.saldoEdit
      );
      if (isValid) {
        if (conceptId.licTot === "S") {
          this.checkDeadlines(payload);
        } else {
          this.confirmEdit(payload);
        }
      } else if (this.alertMessageValidate) {
        this.showDialog = true;
        this.dialogMessage = this.alertMessageValidate;
        this.payloadToSave = payload;
      } else {
        if (conceptId.licTot === "S") {
          this.checkDeadlines(payload);
        } else {
          this.confirmEdit(payload);
        }
      }
    },

    async validarSaldos(payload, conceptLicTot, saldoEdit = 0) {
      try {
        await registrations.dispatch("getCurrentAccount", payload);
        const currentAccounts = registrations.state.currentAccount;
        if (!currentAccounts || !currentAccounts.length) {
          this.errorValidate = false;
          this.alertMessageValidate = "";
          return false;
        }
        let alertMessages = [];
        let isValid = true;

        for (const currentAccount of currentAccounts) {
          const startDate = moment(payload.entrada || payload.fechaEntrada);
          const endDate = moment(payload.originExit || payload.fechaSalida);

          const matchedConcept = currentAccount.conceptos.find(
            (concepto) =>
              concepto.conceptoId === payload.conceptoId &&
              concepto.csCostoId === payload.csCostoId
          );

          if (!matchedConcept) {
            continue; // Pasar a la siguiente cuenta
          }

          const { paramA = 0, paramB = 0 } = matchedConcept;
          let duration, saldoCalculado;

          if (conceptLicTot === "S") {
            duration = endDate.diff(startDate, "days");
            saldoCalculado = paramA + paramB * duration;
          } else {
            const hours = endDate.diff(startDate, "hours");
            saldoCalculado = paramA + paramB * hours;
          }

          let saldoFinal =
            matchedConcept.debCred === "C"
              ? currentAccount.saldo - saldoEdit + saldoCalculado
              : currentAccount.saldo + saldoEdit - saldoCalculado;

          if (
            matchedConcept.debCred === "C" &&
            saldoFinal > currentAccount.topeMax
          ) {
            isValid = false;
            alertMessages.push(
              `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y excede el límite máximo permitido de ${currentAccount.topeMax}.`
            );
          } else if (
            matchedConcept.debCred === "D" &&
            saldoFinal < currentAccount.topeMin
          ) {
            isValid = false;
            alertMessages.push(
              `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y está por debajo del límite mínimo permitido de ${currentAccount.topeMin}.`
            );
          }
        }

        if (!isValid) {
          this.errorValidate = true;
          this.alertMessageValidate = alertMessages
            .join(" ")
            .replace(/\. • /gu, ".<br>• ");
        } else {
          this.errorValidate = false;
          this.alertMessageValidate = "";
        }
        return isValid;
      } catch (error) {
        console.error("Error en la validación de saldos:", error);
        this.errorValidate = true;
        this.alertMessageValidate = "Error al obtener las cuentas actuales.";
        return false;
      }
    },
    confirmEdit(payload) {
      registrations.commit("setEdit", payload);
      registrations
        .dispatch("edit")
        .then(() => {
          this.$store.dispatch("gestionTiempos/getRegis", this.refreshItem);
          this.textAlert = this.$tc("alert.okEdit");
          this.alert = true;
          this.color = "primary";
        })
        .catch((e) => {
          this.textAlert = e.response.data.error.message;
          this.alert = true;
          this.color = "#FF8D58";
        });
      this.cancel();
    },

    deleteItem() {
      if (this.showAudit == true) {
        if (!this.itemsToDelete.audit) {
          this.error = true;
          this.alertValidate = this.$tc("editRegistrations.required");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.dispatchDelete();
        }
      } else {
        this.dispatchDelete();
      }
    },
    // Dispatch delete
    dispatchDelete() {
      registrations.commit("setDeleteItem", this.itemsToDelete);
      registrations
        .dispatch("deleteRegis")
        .then((r) => {
          this.$store.dispatch("gestionTiempos/getRegis", this.refreshItem);
          this.textAlert = "Se eliminó correctamente";
          this.alert = true;
          this.color = "primary";
        })
        .catch(() => {
          this.textAlert = this.$tc("alert.errorDelete");
          this.alert = true;
          this.color = "#FF8D58";
        });
      this.showDelete = false;
    },
    // funcion que se fija si los conceptos son dia u hora
    conceptsHours() {
      let concepts = registrations.state.concepts.filter((item) => {
        return (
          item.conceptId == this.data.concept ||
          item.conceptId == this.editItems.conceptoId
        );
      })[0];
      if (concepts.licTot === "N") {
        this.showHours = true;
        this.isDay = false;
      } else {
        this.showHours = false;
        this.isDay = true;
      }
    },
    // funcion que se fija si se muestra el input de auditoria
    auditTrue() {
      if (this.audit === "true") {
        this.showAudit = true;
      }
    },

    checkArrays() {
      const emptyArrays = [];

      if (this.concepts.length === 0) emptyArrays.push("conceptos");
      if (this.costCenters.length === 0) emptyArrays.push("centro de costos");
      if (this.coments.length === 0) emptyArrays.push("comentarios");

      if (emptyArrays.length === 3) {
        this.message =
          "El rol del operador no posee: conceptos, centro de costos y comentarios.";
        this.showMessage = true;
      } else if (emptyArrays.length > 0) {
        this.message = `El rol del operador no posee: ${emptyArrays.join(
          ", "
        )}.`;
        this.showMessage = true;
      } else {
        this.message = "";
        this.showMessage = false;
      }
    },
    //metodo dispath para llamar a las acciones del store
    dispatch() {
      this.$store.dispatch("gestionTiempos/getAttributes");
      this.$store.dispatch("gestionTiempos/getGroups");
      this.$store.dispatch("gestionTiempos/getSchedule");
      this.$store.dispatch("gestionTiempos/getModels");
      this.$store.dispatch("gestionTiempos/getEmployees");
    },

    //refresca las novedades
    refresh(item) {
      if (this.flagApply) {
        this.refreshItem = this.$store.state.gestionTiempos.filterApply;
        if (typeof item?.data === "object") {
          this.refreshItem.data = JSON.stringify(item.data);
        }
      } else {
        this.refreshItem = item;
        if (typeof item?.data === "object") {
          this.refreshItem.data = JSON.stringify(item.data);
        }
      }
    },
    openAddRegistration() {
      this.alertCheckDeadlinesAction = "add";
      const today = moment().format("YYYY-MM-DD");
      date.commit("setCheckTo", false);
      this.$store.dispatch("gestionTiempos/getEmployees").then(() => {
        this.addRegistration = true;
        this.$store.commit("gestionTiempos/setAddRegistration", true);
        date.commit("setDateTo", today);
        registrations.dispatch("getAudit");
        registrations.dispatch("getConcepts");
        registrations.dispatch("getCsCost");
      });
    },
    async validateAndSubmit(form) {
      this.errorValidate = false;
      this.alertMessageValidate = "";

      const selectedConcept = form.concept;
      const concept = registrations.state.concepts.find(
        (item) => item.conceptId == selectedConcept
      );

      let dateToWithExtraDay = form.exit;
      if (concept && concept.licTot === "S") {
        dateToWithExtraDay = moment(form.exit)
          .add(1, "days")
          .format("YYYY-MM-DD");
      }

      const payload = {
        comentId: this.parseInt(form.audit),
        conceptoId: this.parseInt(form.concept),
        csCostoId: this.parseInt(form.cost),
        empId: this.parseInt(form.employee),
        fecha: date.state.dateFrom,
        entrada: this.formatDate(form.entry, form.start),
        originExit: this.formatDate(dateToWithExtraDay, form.end),
      };

      if (form.obs && form.obs.trim() !== "") {
        payload.observaciones = form.obs;
      }

      const isValid = await this.validar(payload, concept.licTot);
      if (isValid) {
        if (concept && concept.licTot === "S") {
          this.checkDeadlines(payload);
        } else {
          this.saveForm(payload); // Guardar directamente si es válido
        }
      } else if (this.alertMessageValidate) {
        // Si hay un mensaje de advertencia, muestra el diálogo de confirmación
        this.showDialog = true;
        this.dialogMessage = this.alertMessageValidate;
        this.payloadToSave = payload;
      } else {
        // Si no hay datos en currentAccount, guarda directamente sin validación adicional
        if (concept && concept.licTot === "S") {
          this.checkDeadlines(payload);
        } else {
          this.saveForm(payload); // Guardar directamente si es válido
        }
      }
    },

    async validar(payload, conceptLicTot) {
      try {
        await registrations.dispatch("getCurrentAccount", payload);
        const currentAccounts = registrations.state.currentAccount;
        if (!currentAccounts || !currentAccounts.length) {
          this.errorValidate = false;
          this.alertMessageValidate = "";
          return false;
        }

        let alertMessages = [];
        let isValid = true;

        for (const currentAccount of currentAccounts) {
          const startDate = moment(payload.entrada);
          const endDate = moment(payload.originExit);

          const matchedConcept = currentAccount.conceptos.find(
            (concepto) =>
              concepto.conceptoId === payload.conceptoId &&
              concepto.csCostoId === payload.csCostoId
          );

          if (!matchedConcept) {
            continue;
          }

          const { paramA = 0, paramB = 0 } = matchedConcept;

          let duration, saldoCalculado;

          if (conceptLicTot === "S") {
            duration = endDate.diff(startDate, "days");
            saldoCalculado = paramA + paramB * duration;
          } else {
            const hours = endDate.diff(startDate, "hours");
            saldoCalculado = paramA + paramB * hours;
          }

          let saldoFinal;
          if (matchedConcept.debCred === "C") {
            saldoFinal = currentAccount.saldo + saldoCalculado;
          } else {
            saldoFinal = currentAccount.saldo - saldoCalculado;
          }

          if (
            matchedConcept.debCred === "C" &&
            saldoFinal > currentAccount.topeMax
          ) {
            isValid = false;
            alertMessages.push(
              `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y excede el límite máximo permitido de ${currentAccount.topeMax}.`
            );
          } else if (
            matchedConcept.debCred === "D" &&
            saldoFinal < currentAccount.topeMin
          ) {
            isValid = false;
            alertMessages.push(
              `• El saldo final de "${currentAccount.nomCuenta}" es ${saldoFinal} y está por debajo del límite mínimo permitido de ${currentAccount.topeMin}.`
            );
          }
        }

        if (!isValid) {
          this.errorValidate = true;
          this.alertMessageValidate = alertMessages
            .join(" ")
            .replace(/\. • /gu, ".<br>• ");
        } else {
          this.errorValidate = false;
          this.alertMessageValidate = "";
        }

        return isValid;
      } catch (error) {
        console.error("Error en la validación:", error);
        this.errorValidate = true;
        this.alertMessageValidate = "Error al obtener las cuentas actuales.";
        return false;
      }
    },
    checkDeadlines(payload) {
      if (this.alertCheckDeadlinesAction === "add") {
        const from = moment(payload.entrada, "YYYY-MM-DD");
        const to = moment(payload.originExit, "YYYY-MM-DD");

        const diffDays = to.diff(from, "days");

        if (diffDays > 10) {
          this.alertCheckDeadlines = true;
          this.payloadToSave = payload;
        } else {
          this.saveForm(payload);
        }
      } else if (this.alertCheckDeadlinesAction === "edit") {
        const from = moment(payload.fechaEntrada, "YYYY-MM-DD");
        const to = moment(payload.fechaSalida, "YYYY-MM-DD");

        const diffDays = to.diff(from, "days");

        if (diffDays > 10) {
          this.alertCheckDeadlines = true;
          this.payloadToSave = payload;
        } else {
          this.confirmEdit(payload);
        }
      }
    },

    confirmCheckDeadlines() {
      this.alertCheckDeadlines = false;
      if (this.payloadToSave) {
        if (this.alertCheckDeadlinesAction === "add") {
          this.saveForm(this.payloadToSave);
          this.payloadToSave = null;
        } else {
          this.confirmEdit(this.payloadToSave);
          this.payloadToSave = null;
        }
      }
    },

    saveForm(payload) {
      registrations.commit("setNewRegis", payload);
      registrations
        .dispatch("getNewRegis")
        .then(() => {
          this.textAlert = "Se agregó la registración";
          this.alert = true;
          this.color = "primary";
          if (this.tab === 1) {
            this.$store.dispatch("gestionTiempos/getRegis", this.refreshItem);
          }
          this.reset();
        })
        .catch((e) => {
          console.error(e);
          this.alert = true;
          this.textAlert =
            e.response?.data?.error?.message || "Error desconocido.";
          this.color = "#FF8D58";
        });
    },

    async confirmDialog(response) {
      this.showDialog = false;
      if (response) {
        this.saveForm(this.payloadToSave);
      }
      this.payloadToSave = null;
    },

    parseInt(string) {
      return parseInt(string, 10);
    },

    formatDate(date, hour) {
      const hourFormat = !hour ? "00:00" : hour;
      return `${date}T${hourFormat}:00.000`;
    },

    reset() {
      this.alertCheckDeadlines = false;
      this.addRegistration = false;
      this.$store.commit("gestionTiempos/setAddRegistration", false);
    },
    flag(item) {
      this.flagApply = item;
    },

    onRefreshItem() {
      this.loading = true;
      const from = moment(this.$store.state.gestionTiempos.date);
      const to = moment(this.$store.state.gestionTiempos.dateTo);
      const max_time = to.diff(from, "days");
      this.color = "#FF8D58";
      if (max_time > 365) {
        this.textAlert = this.$tc("date.year");
        this.alert = true;
      } else if (from > to) {
        (this.textAlert = this.$tc("date.fromGreater")), (this.alert = true);
      } else if (this.flagApply) {
        const data = this.$store.state.gestionTiempos.dataFilterApply;
        this.$store.dispatch("gestionTiempos/newControllerApply", data);
      } else {
        if (this.tab === 0) {
          this.$store
            .dispatch("gestionTiempos/newController", this.refreshItem)
            .then((response) => {
              if (!response) {
                this.alert = true;
                this.color = "#FF8D58";
                this.textAlert = this.$tc("gestionTiempos.alerRefresh");
              }
            });
        } else {
          this.$store
            .dispatch("gestionTiempos/getRegis", this.refreshItem)
            .then((response) => {
              if (!response) {
                this.alert = true;
                this.color = "#FF8D58";
                this.textAlert = this.$tc("gestionTiempos.alerRefresh");
              }
            });
        }
      }
      setTimeout(() => {
        this.loading = false;
        this.alert = false;
      }, 5000);
      this.deselectItems = [];
      this.$store.commit("gestionTiempos/setDeselectItems", this.deselectItems);
    },

    itemsSelections(items) {
      this.$store.commit("gestionTiempos/setDeselectItems", items);
      this.deselectItems = items;
    },

    //firma
    firnNovelty() {
      this.deselectItems = this.$store.state.gestionTiempos.deselectItems;
      if (this.deselectItems === 0) {
        this.alert = true;
        this.color = "#FF8D58";
        this.textAlert = this.$tc("assigNovelty.notItemsFirms");
      } else {
        signNovelty.commit("setFirmNovelty", this.deselectItems);
        signNovelty
          .dispatch("firmNovelty")
          .then((response) => {
            this.loading = true;
            setTimeout(() => {
              this.onRefreshItem();
            }, 2000);
          })
          .catch((e) => {
            this.alert = true;
            this.color = "#FF8D58";
            this.textAlert = "Error: no se pudo firmar la Novedad";
          });
        this.deselectItems = [];
        this.$store.commit(
          "gestionTiempos/setDeselectItems",
          this.deselectItems
        );
      }
    },
    // no firma
    notFirmNovelty() {
      this.deselectItems = this.$store.state.gestionTiempos.deselectItems;
      if (this.deselectItems === 0) {
        this.alert = true;
        this.color = "#FF8D58";
        this.textAlert = this.$tc("assigNovelty.notItemsFirms");
      } else {
        signNovelty.commit("setNotFirm", this.deselectItems);
        signNovelty
          .dispatch("notFirmNovelty")
          .then((response) => {
            this.loading = true;
            setTimeout(() => {
              this.onRefreshItem();
            }, 2000);
          })
          .catch((e) => {
            this.alert = true;
            this.color = "#FF8D58";
            this.textAlert = "error! No se puede retirar la firma";
          });
      }
      this.deselectItems = [];
      this.$store.commit("gestionTiempos/setDeselectItems", this.deselectItems);
    },
  },
};
</script>

<style scoped>
.row__ {
  min-width: 100% !important;
}
.card-container {
  height: 80vh;

  margin: 0px !important;
  padding: 0px !important;
  min-width: 100% !important;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

@-moz-document url-prefix() {
  .v-data-table {
    max-width: 100%;
  }

  .search-input {
    max-width: 200px;
    height: 50px;
  }

  .search {
    margin-right: 10px;
  }
}

.firms {
  display: flex;
  align-items: center;
  justify-content: flex-end !important;
}

.search {
  display: flex;
  max-width: 500px;
}
.search-input {
  height: 58px;
}
.row-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.options {
  width: 250px;
}

.dataTable {
  width: 100%;
  overflow: overlay;
  margin-top: 30px;
}

.filter {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-height: 40px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.date {
  display: flex;
  flex-direction: row;
  background-color: rgba(202, 200, 200, 0.5);
  border-radius: 50px;
  max-height: 50px;
  justify-content: center;
  align-items: center;
  max-width: 290px;
}

.snackbar {
  text-align: center !important;
}

#btn-actions {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid #39537a !important;
  background-color: #ffffff;
}

#btn-actions:hover {
  background-color: #39537a !important;
  color: white !important;
}

.v-btn:not(.v-btn--round).v-size--default {
  min-width: 0px !important;
  padding: 0px !important;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 31px;
}

.btn-refresh {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  border: 1px solid #39537a !important;
  background-color: #ffffff;
}

.btn-refresh:hover {
  background-color: #82a1d0 !important;
  color: #1d3861 !important;
}

.icon-btn-actions {
  color: #39537a !important;
}

.icon-btn-actions:hover {
  color: white !important;
}

#btn-disabled.v-btn--disabled {
  background-color: #bdbdc0 !important;
  border: none;
}

@media (min-width: 1078px) and (max-width: 1273px) {
  .row-container {
    flex-direction: row;
    align-items: center;
  }

  .firms {
    order: 0;
    margin-top: 10px !important;
    margin-left: 25px;
    width: 100%;
    align-self: flex-end !important;
  }
}

@media (min-width: 350px) and (max-width: 1077px) {
  .row-container {
    flex-direction: column;
    align-items: start;
  }

  .date__ {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .firms {
    margin-bottom: 20px;
  }

  .search {
    max-width: 500px;
  }
}
</style>
